const fr = 'FunctionRooms';

const classes = {
	functionRoomShow: `${fr}-additional-show`,
	functionRoomAddHide: `${fr}-add-hide`,
};

const selectors = {
	baseContainer: '.RfpForm',
	functionRoomsAdd: `.${fr}-add`,
	functionRoomRemove: `.${fr}-remove`,
	functionRoomContainer: `.${fr}-additional`,
	functionRoomShowing: `.${classes.functionRoomShow}`,
};

function initForm(element) {
	let $form = $(element);

	addFunctionRoomInteractions($form);
}

function addFunctionRoomInteractions($form) {
	let $addButton = $form.find(selectors.functionRoomsAdd);

	//hides the add button if the max number of rooms showing
	let toggleAdd = () => {
		if ($form.find(selectors.functionRoomShowing).length === 4) {
			$addButton.addClass(classes.functionRoomAddHide);
		} else {
			$addButton.removeClass(classes.functionRoomAddHide);
		}
	};

	//handle the add button click
	$addButton.on('click', e => {
		let $allAdditional = $form.find(selectors.functionRoomContainer);
		let $notShowing = $allAdditional.not(selectors.functionRoomShowing);
		let $container = $notShowing.first();

		$container.addClass(classes.functionRoomShow);
		$container.find('input').first().focus();
		toggleAdd();

		return false;
	});

	//handle the remove button click for the additionals
	let $allRemoved = $form.find(selectors.functionRoomRemove);
	$form.find(selectors.functionRoomRemove).each((i, button) => {
		let $button = $(button);
		$button.on('click', e => {
			let $parent = $button.closest(selectors.functionRoomContainer);
			$parent.removeClass(classes.functionRoomShow);

			toggleAdd();
			return false;
		});
	});
}
/**
 * Initiates all the accordions on the page
 * @return {undefined}
 */
export default function init() {
	$(selectors.baseContainer).each((index, element) => initForm(element));
}
